import { LegalPageLayout } from './LegalPageLayout';

export function CodiceEticoPage() {
  return (
    <LegalPageLayout title="Codice Etico dei Collaboratori">
      <p className="mt-2 text-sm text-neutral-500">Ultima revisione: 7 Maggio 2026</p>
                  
                    <p>
                      Il presente Codice Etico definisce i principi, i valori e le regole di comportamento che tutti i
                      consulenti e collaboratori della piattaforma Klaro7 sono tenuti a rispettare nello svolgimento
                      delle proprie attività.
                    </p>
                    <p>
                      Klaro7 si impegna a offrire un servizio basato su professionalità, rispetto, trasparenza e
                      responsabilità, con l&apos;obiettivo di garantire agli utenti un ambiente sicuro e corretto per
                      l&apos;utilizzo dei servizi di consulenza.
                    </p>
                    <p>
                      <strong>
                        Il rispetto del presente Codice Etico costituisce condizione essenziale per la
                        collaborazione con Klaro7.
                      </strong>
                    </p>
                    <p>
                      La violazione delle disposizioni qui contenute può comportare provvedimenti disciplinari fino
                      alla sospensione o alla cessazione del rapporto di collaborazione, secondo quanto
                      previsto dal Contratto Operatore.
                    </p>
      
                    <h2>1. Principi fondamentali di condotta</h2>
      
                    <h3>Rispetto e professionalità</h3>
                    <p>
                      Il consulente deve mantenere in ogni momento un comportamento cortese, rispettoso ed
                      empatico nei confronti dell&apos;utente.
                    </p>
                    <p>Non sono ammessi:</p>
                    <ul>
                      <li>linguaggi offensivi o volgari</li>
                      <li>atteggiamenti aggressivi</li>
                      <li>giudizi morali o personali sulla vita dell&apos;utente</li>
                    </ul>
                    <p>Il consulto deve sempre svolgersi in un clima di dialogo, rispetto e professionalità.</p>
      
                    <h3>Onestà e trasparenza</h3>
                    <p>
                      Il consulente è tenuto a presentare le proprie competenze, esperienze e modalità di consulto
                      in modo chiaro e veritiero.
                    </p>
                    <p>Non è consentito:</p>
                    <ul>
                      <li>dichiarare falsamente competenze o qualifiche</li>
                      <li>attribuirsi poteri o capacità soprannaturali in modo ingannevole</li>
                      <li>promettere risultati certi o garantiti</li>
                    </ul>
      
                    <h3>Interesse dell&apos;utente</h3>
                    <p>Il consulente deve operare sempre nell&apos;interesse dell&apos;utente, favorendo:</p>
                    <ul>
                      <li>riflessione personale</li>
                      <li>consapevolezza</li>
                      <li>rispetto della libertà di scelta</li>
                    </ul>
                    <p>
                      È vietata qualsiasi forma di manipolazione emotiva o psicologica finalizzata a prolungare
                      o moltiplicare i consulti.
                    </p>
      
                    <h2>2. Limiti di competenza e divieti assoluti</h2>
                    <p>
                      Il consulente deve sempre chiarire, quando necessario, che il consulto ha finalità di
                      intrattenimento o supporto spirituale e non sostituisce in alcun modo il parere di
                      professionisti qualificati.
                    </p>
                    <p>È pertanto assolutamente vietato fornire consulenze o indicazioni nei seguenti ambiti:</p>
      
                    <h3>Salute</h3>
                    <ul>
                      <li>diagnosi mediche</li>
                      <li>terapie o cure</li>
                      <li>consigli psicologici o psichiatrici</li>
                      <li>gestione di malattie o gravidanze</li>
                    </ul>
      
                    <h3>Finanza e ambito legale</h3>
                    <ul>
                      <li>consulenze finanziarie</li>
                      <li>investimenti o operazioni di borsa</li>
                      <li>consulenze legali o fiscali</li>
                    </ul>
      
                    <h3>Etica e sicurezza</h3>
                    <p>È vietato:</p>
                    <ul>
                      <li>suggerire attività illegali</li>
                      <li>incoraggiare comportamenti pericolosi</li>
                      <li>
                        promuovere servizi esoterici esterni a pagamento (riti, maledizioni, pratiche magiche
                        non autorizzate)
                      </li>
                    </ul>
      
                    <h3>Creazione di dipendenza</h3>
                    <p>
                      Il consulente deve evitare qualsiasi comportamento che possa creare dipendenza emotiva
                      o psicologica nell&apos;utente.
                    </p>
                    <p>Sono vietati:</p>
                    <ul>
                      <li>inviti insistenti a effettuare nuovi consulti</li>
                      <li>sollecitazioni a consulti ripetitivi e ravvicinati senza reale necessità</li>
                      <li>messaggi che inducano paura o ansia per generare ulteriori consulti</li>
                    </ul>
      
                    <h3>Divieto di previsioni allarmistiche</h3>
                    <p>È severamente vietato:</p>
                    <ul>
                      <li>predire morti</li>
                      <li>malattie gravi</li>
                      <li>disgrazie o eventi tragici</li>
                    </ul>
                    <p>
                      soprattutto se tali affermazioni possono creare stati di ansia o vulnerabilità emotiva
                      nell&apos;utente.
                    </p>
      
                    <h2>3. Gestione della vulnerabilità e delle situazioni di crisi</h2>
                    <p>
                      Il consulente deve prestare particolare attenzione a eventuali segnali di grave vulnerabilità
                      emotiva o psicologica da parte dell&apos;utente.
                    </p>
                    <p>Qualora emergano situazioni di:</p>
                    <ul>
                      <li>forte crisi personale</li>
                      <li>stato di disperazione</li>
                      <li>intenzioni autolesive o suicidarie</li>
                    </ul>
                    <p>
                      il consulente ha l&apos;obbligo di interrompere il consulto e invitare con sensibilità l&apos;utente a
                      rivolgersi immediatamente a:
                    </p>
                    <ul>
                      <li>professionisti sanitari qualificati</li>
                      <li>psicologi o medici</li>
                      <li>servizi di emergenza o supporto psicologico</li>
                    </ul>
                    <p>Questa misura è adottata per tutelare la sicurezza e il benessere dell&apos;utente.</p>
      
                    <h2>4. Tutela dei minori</h2>
                    <p>
                      È severamente vietato effettuare consulenze a soggetti che dichiarino o facciano presumere
                      di essere minorenni.
                    </p>
                    <p>In tali casi il consulente deve:</p>
                    <ol>
                      <li>interrompere immediatamente la consulenza</li>
                      <li>segnalare l&apos;evento alla piattaforma Klaro7</li>
                    </ol>
      
                    <h2>5. Riservatezza e non sollecitazione</h2>
      
                    <h3>Riservatezza</h3>
                    <p>
                      Il consulente è tenuto al più stretto obbligo di riservatezza su tutte le informazioni apprese
                      durante i consulti.
                    </p>
                    <p>È vietato divulgare:</p>
                    <ul>
                      <li>contenuti delle conversazioni</li>
                      <li>dati personali degli utenti</li>
                      <li>qualsiasi informazione sensibile relativa ai consulti.</li>
                    </ul>
      
                    <h3>Divieto di contatti esterni</h3>
                    <p>Per garantire la sicurezza e la correttezza del servizio, è assolutamente vietato:</p>
                    <ul>
                      <li>scambiare numeri di telefono</li>
                      <li>condividere email personali</li>
                      <li>indirizzare gli utenti verso altri siti o servizi esterni</li>
                    </ul>
                    <p>
                      La violazione di questa regola è soggetta alla clausola penale di €5.000, come previsto dal
                      contratto operatore.
                    </p>
      
                    <h2>6. Violazioni del Codice Etico</h2>
                    <p>La violazione del presente Codice Etico costituisce grave inadempimento contrattuale.</p>
                    <p>Klaro7 si riserva il diritto di adottare i seguenti provvedimenti:</p>
                    <ul>
                      <li>richiamo formale</li>
                      <li>sospensione temporanea dell&apos;account</li>
                      <li>risoluzione immediata del contratto</li>
                      <li>applicazione delle clausole penali previste</li>
                    </ul>
                    <p>
                      Le decisioni vengono adottate dalla piattaforma Klaro7 con l&apos;obiettivo di tutelare la qualità
                      del servizio e la sicurezza degli utenti.
                    </p>
    </LegalPageLayout>
  );
}
